export default function Value(props) {
  const { input } = props;
  return (input.value)
}